// 쇼링장 관리 (admin) — 쇼링장 마스터 CRUD + 포탈 계정 발급 (배차 D4, 2026-06-02)
//   백엔드: routes/shoringYards.js (GET/POST/PUT/DELETE /shoring-yards, POST /:id/account). 배차(D4)에서 배정.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';

function ShoringYardAdmin({ showToast }) {
  var st = showToast || function () {};
  var listState = useState([]); var yards = listState[0]; var setYards = listState[1];
  var formState = useState({ name: '', bizNo: '', ceo: '', tel: '', email: '', addr: '' });
  var form = formState[0]; var setForm = formState[1];
  var credState = useState(null); var cred = credState[0]; var setCred = credState[1];

  function load() {
    authFetch(API + '/shoring-yards').then(function (r) { return r.json(); })
      .then(function (d) { if (Array.isArray(d)) setYards(d); }).catch(function () {});
  }
  useEffect(function () { load(); }, []);

  function create() {
    if (!form.name.trim()) { st('쇼링장명을 입력하세요', 'err'); return; }
    authFetch(API + '/shoring-yards', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('쇼링장 추가됨', ''); setForm({ name: '', bizNo: '', ceo: '', tel: '', email: '', addr: '' }); load(); }
        else st((d && d.error) || '추가 실패', 'err');
      }).catch(function () { st('추가 실패', 'err'); });
  }
  function toggleActive(y) {
    authFetch(API + '/shoring-yards/' + y.id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ active: y.active ? 0 : 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) load(); else st((d && d.error) || '수정 실패', 'err'); }).catch(function () { st('수정 실패', 'err'); });
  }
  function issueAccount(y) {
    var reissue = !!y.accountUserId;
    var msg = reissue
      ? (y.name + ' 계정(' + y.accountUserId + ')의 비밀번호를 재발급할까요? 기존 비밀번호는 무효화됩니다.')
      : (y.name + ' 의 포탈 로그인 계정을 발급할까요?');
    if (!window.confirm(msg)) return;
    authFetch(API + '/shoring-yards/' + y.id + '/account', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { setCred({ name: y.name, userId: d.userId, tempPassword: d.tempPassword, reissued: d.reissued }); load(); }
        else st((d && d.error) || '발급 실패', 'err');
      }).catch(function () { st('발급 실패', 'err'); });
  }
  function remove(y) {
    if (!window.confirm(y.name + ' 쇼링장을 삭제할까요? (배차 배정 있으면 불가)')) return;
    authFetch(API + '/shoring-yards/' + y.id, { method: 'DELETE' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('삭제됨', ''); load(); } else st((d && d.error) || '삭제 실패', 'err'); })
      .catch(function () { st('삭제 실패', 'err'); });
  }

  var inp = { padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, boxSizing: 'border-box' };
  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'🏭 쇼링장 관리'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20 }}>{'운송된 차량의 쇼링·면장용 사진을 업로드하는 현장. 포탈 계정 발급 후 배차에서 배정합니다.'}</div>

      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginBottom: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#475569', marginBottom: 10 }}>{'쇼링장 등록'}</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 8, marginBottom: 10 }}>
          <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} placeholder="쇼링장명 *" style={inp} />
          <input value={form.bizNo} onChange={function (e) { setForm(Object.assign({}, form, { bizNo: e.target.value })); }} placeholder="사업자번호" style={inp} />
          <input value={form.ceo} onChange={function (e) { setForm(Object.assign({}, form, { ceo: e.target.value })); }} placeholder="대표/담당자" style={inp} />
          <input value={form.tel} onChange={function (e) { setForm(Object.assign({}, form, { tel: e.target.value })); }} placeholder="연락처" style={inp} />
          <input value={form.email} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} placeholder="이메일" style={inp} />
          <input value={form.addr} onChange={function (e) { setForm(Object.assign({}, form, { addr: e.target.value })); }} placeholder="주소" style={inp} />
        </div>
        <button onClick={create} style={{ padding: '8px 20px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'+ 등록'}</button>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
          <thead><tr style={{ background: '#f8fafc' }}>
            <th style={thS}>{'쇼링장명'}</th><th style={thS}>{'담당자'}</th><th style={thS}>{'연락처'}</th>
            <th style={thC}>{'로그인 계정'}</th><th style={thC}>{'상태'}</th><th style={thC}>{'관리'}</th>
          </tr></thead>
          <tbody>
            {yards.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'등록된 쇼링장이 없습니다'}</td></tr>}
            {yards.map(function (y) {
              return (
                <tr key={y.id} style={{ borderTop: '1px solid #f1f5f9', opacity: y.active ? 1 : 0.5 }}>
                  <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{y.name}</td>
                  <td style={tdS}>{y.ceo || '-'}</td>
                  <td style={tdS}>{y.tel || '-'}</td>
                  <td style={tdC}>
                    {y.accountUserId
                      ? <span style={{ fontSize: 11, fontWeight: 700, color: '#0369a1', fontFamily: 'monospace' }}>{y.accountUserId}</span>
                      : <span style={{ fontSize: 11, color: '#94a3b8' }}>{'미발급'}</span>}
                  </td>
                  <td style={tdC}><span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: y.active ? '#16a34a' : '#94a3b8', borderRadius: 10, padding: '2px 8px' }}>{y.active ? '활성' : '비활성'}</span></td>
                  <td style={tdC}>
                    <button onClick={function () { issueAccount(y); }} style={{ marginRight: 4, padding: '3px 10px', border: '1px solid #bae6fd', background: '#f0f9ff', color: '#0369a1', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{y.accountUserId ? '비번 재발급' : '계정 발급'}</button>
                    <button onClick={function () { toggleActive(y); }} style={{ marginRight: 4, padding: '3px 10px', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{y.active ? '비활성화' : '활성화'}</button>
                    <button onClick={function () { remove(y); }} style={{ padding: '3px 10px', border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'삭제'}</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {cred && (
        <div onClick={function () { setCred(null); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 12, padding: 24, width: 380, maxWidth: '90vw' }}>
            <div style={{ fontSize: 17, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{cred.reissued ? '🔑 비밀번호 재발급됨' : '🔑 계정 발급됨'}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 16 }}>{cred.name + ' — 아래 정보를 쇼링장에 전달하세요.'}</div>
            <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>{'아이디'}</div>
              <div style={{ fontSize: 16, fontWeight: 800, fontFamily: 'monospace', color: NAVY, marginBottom: 10 }}>{cred.userId}</div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>{'임시 비밀번호'}</div>
              <div style={{ fontSize: 18, fontWeight: 800, fontFamily: 'monospace', color: '#dc2626', letterSpacing: 1 }}>{cred.tempPassword}</div>
            </div>
            <div style={{ fontSize: 12, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '8px 10px', marginBottom: 16 }}>{'⚠️ 비밀번호는 지금만 표시됩니다. 닫으면 다시 볼 수 없으니 즉시 전달하세요.'}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={function () { try { navigator.clipboard.writeText(cred.userId + ' / ' + cred.tempPassword); st('복사됨', ''); } catch (e) { st('복사 실패', 'err'); } }} style={{ flex: 1, padding: '9px 0', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'복사'}</button>
              <button onClick={function () { setCred(null); }} style={{ flex: 1, padding: '9px 0', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'닫기'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thC = Object.assign({}, thS, { textAlign: 'center' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdC = Object.assign({}, tdS, { textAlign: 'center' });

export default ShoringYardAdmin;
